import request from '../request.js';

/**
 * Подтвердить начало прослушивания аудиогида
 * @param {String} hash
 * @return {Promise}
 */
export const acceptAudioguideListening = (hash) => request({
  url: '/audioguide/start-listening',
  type: 'GET',
  needOverlay: true,
  data: {
    hash,
  },
});

/**
 * Запросить файл аудиогида
 * @param {String} hash
 * @return {Promise}
 */
export const getAudioguideFile = (hash) => request({
  url: '/audioguide/stream-audio',
  type: 'GET',
  needOverlay: true,
  data: {
    hash,
  },
});
